import { render } from "./EmailAccounts.vue?vue&type=template&id=84289cce&scoped=true"
import script from "./EmailAccounts.vue?vue&type=script&lang=js"
export * from "./EmailAccounts.vue?vue&type=script&lang=js"

import "./EmailAccounts.vue?vue&type=style&index=0&id=84289cce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84289cce"]])

export default __exports__